// extracted by mini-css-extract-plugin
export default {"Head":"Head_Head__ZqA1y","link":"Head_link__glgZ0"};